import { render, staticRenderFns } from "./MfDialog.vue?vue&type=template&id=3b33ae13&scoped=true&"
import script from "./MfDialog.vue?vue&type=script&lang=js&"
export * from "./MfDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b33ae13",
  null
  
)

export default component.exports